import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5e1b163b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5e1b163b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1b163b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1b163b')) {
      api.createRecord('5e1b163b', component.options)
    } else {
      api.reload('5e1b163b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5e1b163b&scoped=true", function () {
      api.rerender('5e1b163b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teacher/index.vue"
export default component.exports